import { render, staticRenderFns } from "./PercentualText.vue?vue&type=template&id=188b8823&scoped=true&"
import script from "./PercentualText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PercentualText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PercentualText.vue?vue&type=style&index=0&id=188b8823&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b8823",
  null
  
)

export default component.exports